// Content schema describing which translation paths are editable from the admin.
// Each section groups related fields. Each field references a path inside the
// `translations[lang]` object (e.g. "hero.subtitle"). Arrays of strings use
// `type: "list"`; arrays of {t,d} use `type: "list-td"`.
export const CONTENT_SCHEMA = [
  {
    key: "hero",
    title: "Home — Hero",
    fields: [
      { path: "hero.eyebrow", label: "Eyebrow (sopra il titolo)", type: "text" },
      { path: "hero.subtitle", label: "Sottotitolo", type: "textarea" },
      { path: "hero.tag", label: "Tag line ('Dove arriva il pubblico…')", type: "text" },
      { path: "hero.sticker", label: "Sticker ('Tutto è possibile')", type: "text" },
      { path: "hero.rotatorWords", label: "Parole rotanti (Sogna./Crea./Realizza./Vivi.)", type: "list" },
    ],
  },
  {
    key: "manifesto",
    title: "Manifesto",
    fields: [
      { path: "manifesto.eyebrow", label: "Eyebrow", type: "text" },
      { path: "manifesto.lead", label: "Frase d'apertura (script gold)", type: "textarea" },
      { path: "manifesto.body", label: "Testo manifesto", type: "textarea" },
      { path: "manifesto.claim", label: "Claim finale tra virgolette", type: "text" },
    ],
  },
  {
    key: "pillars",
    title: "I 5 Pilastri",
    fields: [
      { path: "pillars.eyebrow", label: "Eyebrow", type: "text" },
      { path: "pillars.title", label: "Titolo", type: "text" },
      { path: "pillars.subtitle", label: "Sottotitolo", type: "textarea" },
      { path: "pillars.items", label: "Pilastri (titolo | descrizione)", type: "list-td" },
    ],
  },
  {
    key: "common-ctas",
    title: "Bottoni e CTA generali",
    fields: [
      { path: "common.requestProposal", label: "Bottone — Richiedi una proposta", type: "text" },
      { path: "common.discoverFormats", label: "Bottone — Scopri i nostri format", type: "text" },
      { path: "common.discoverFormat", label: "Bottone — Scopri il format", type: "text" },
      { path: "common.contactUs", label: "Bottone — Contattaci ora", type: "text" },
      { path: "common.send", label: "Bottone — Invia richiesta", type: "text" },
      { path: "common.thankYou", label: "Messaggio di conferma form", type: "text" },
    ],
  },
  {
    key: "impact",
    title: "Home — Numeri & Impatto",
    fields: [
      { path: "impact.eyebrow", label: "Eyebrow", type: "text" },
      { path: "impact.title", label: "Titolo", type: "text" },
      { path: "impact.subtitle", label: "Sottotitolo", type: "textarea" },
    ],
  },
  {
    key: "about",
    title: "Home — Chi siamo",
    fields: [
      { path: "about.eyebrow", label: "Eyebrow", type: "text" },
      { path: "about.title", label: "Titolo", type: "text" },
      { path: "about.body", label: "Testo descrittivo", type: "textarea" },
      { path: "about.pillars", label: "Pillars (4 punti, uno per riga)", type: "list" },
    ],
  },
  {
    key: "services",
    title: "Cosa facciamo (servizi)",
    fields: [
      { path: "services.eyebrow", label: "Eyebrow", type: "text" },
      { path: "services.title", label: "Titolo", type: "text" },
      { path: "services.items", label: "Servizi (titolo | descrizione)", type: "list-td" },
    ],
  },
  {
    key: "formats",
    title: "I nostri Format (sezione)",
    fields: [
      { path: "formats.eyebrow", label: "Eyebrow", type: "text" },
      { path: "formats.title", label: "Titolo", type: "text" },
      { path: "formats.subtitle", label: "Sottotitolo", type: "textarea" },
    ],
  },
  {
    key: "organizers",
    title: "Per organizzatori",
    fields: [
      { path: "organizers.eyebrow", label: "Eyebrow", type: "text" },
      { path: "organizers.title", label: "Titolo", type: "text" },
      { path: "organizers.body", label: "Testo", type: "textarea" },
      { path: "organizers.bullets", label: "Punti chiave (uno per riga)", type: "list" },
    ],
  },
  {
    key: "why",
    title: "Perché sceglierci",
    fields: [
      { path: "why.eyebrow", label: "Eyebrow", type: "text" },
      { path: "why.title", label: "Titolo", type: "text" },
      { path: "why.points", label: "Punti (titolo | descrizione)", type: "list-td" },
    ],
  },
  {
    key: "cta",
    title: "Call to Action centrale",
    fields: [
      { path: "cta.eyebrow", label: "Eyebrow", type: "text" },
      { path: "cta.title", label: "Titolo", type: "text" },
      { path: "cta.body", label: "Testo", type: "textarea" },
    ],
  },
  {
    key: "gallery",
    title: "Galleria (intestazione)",
    fields: [
      { path: "gallery.eyebrow", label: "Eyebrow", type: "text" },
      { path: "gallery.title", label: "Titolo", type: "text" },
      { path: "gallery.subtitle", label: "Sottotitolo", type: "textarea" },
    ],
  },
  {
    key: "events",
    title: "Eventi / Case history (intestazione)",
    fields: [
      { path: "events.eyebrow", label: "Eyebrow", type: "text" },
      { path: "events.title", label: "Titolo", type: "text" },
      { path: "events.subtitle", label: "Sottotitolo", type: "textarea" },
    ],
  },
  {
    key: "contact",
    title: "Contatti (intestazione)",
    fields: [
      { path: "contact.eyebrow", label: "Eyebrow", type: "text" },
      { path: "contact.title", label: "Titolo", type: "text" },
      { path: "contact.subtitle", label: "Sottotitolo", type: "textarea" },
    ],
  },
  {
    key: "careers",
    title: "Lavora con noi",
    fields: [
      { path: "careers.eyebrow", label: "Eyebrow", type: "text" },
      { path: "careers.title", label: "Titolo", type: "text" },
      { path: "careers.body", label: "Testo", type: "textarea" },
      { path: "careers.cta", label: "Bottone candidatura", type: "text" },
    ],
  },
  {
    key: "footer",
    title: "Footer",
    fields: [
      { path: "footer.tagline", label: "Tagline footer", type: "textarea" },
      { path: "footer.copy", label: "Copyright (suffisso)", type: "text" },
    ],
  },
];

// Get a value by dot-path from an object
export function getByPath(obj, path) {
  if (!obj) return undefined;
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

// Set a value by dot-path on an object (returns a new object, immutable)
export function setByPath(obj, path, value) {
  const keys = path.split(".");
  const out = { ...(obj || {}) };
  let cur = out;
  for (let i = 0; i < keys.length - 1; i++) {
    const k = keys[i];
    cur[k] = { ...(cur[k] || {}) };
    cur = cur[k];
  }
  cur[keys[keys.length - 1]] = value;
  return out;
}
